import { useSiteLocale } from '../../hooks/useLocalizedNavigate';
import { Link } from 'react-router-dom';
import UserMenu from './UserMenu/UserMenu';
import { useAppSelector } from '../../store/hooks';
import Title from '../common/Title/Title';
import SearchBar from './SearchBar/SearchBar';
import { Button, TextField } from '../common';
import Notifications from './Notifications/Notifications';
import { useTranslation } from '../../hooks/translations/TranslationProvider';
import { useState } from 'react';
import { useIconFontReady } from '../common/Icon/useIconFontReady';
import { withSiteLocale } from '../../utils/helpers';

import './header.css';

const Header = () => {
    const auth = useAppSelector(state => state.auth);
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const iconFontReady = useIconFontReady();

    const isAuthenticated = !!auth.authData;
    const locale = useSiteLocale();
    const navElementColor = isOpen ? 'white' : 'subtitle';
    const navElementWeight = 'bold';

    return (
        <header>
            <div className="inner-header">
                <div className="burger" onClick={() => setIsOpen(!isOpen)}>
                    <span />
                    <span />
                    <span />
                </div>
                <div className="left-header">
                    <Link
                        to={
                            isAuthenticated
                                ? `/${locale}/home`
                                : withSiteLocale('/', locale)
                        }
                        className="header-logo text-xl"
                        onClick={() => setIsOpen(false)}
                    >
                        <Title text="Sportwice" color="green" size="l" />
                    </Link>
                </div>
                <nav className={`${isOpen ? 'open' : ''}`}>
                    {auth.meIsLoading ? null : (
                        <>
                            {isAuthenticated ? (
                                <>
                                    <Link
                                        to={`/${locale}/my-events`}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <TextField
                                            color={navElementColor}
                                            size="s"
                                            weight={navElementWeight}
                                        >
                                            {t('header.myEvents')}
                                        </TextField>
                                    </Link>
                                    <Link
                                        to={`/${locale}/finder`}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <TextField
                                            color={navElementColor}
                                            size="s"
                                            weight={navElementWeight}
                                        >
                                            {t('header.finder')}
                                        </TextField>
                                    </Link>
                                    <Link
                                        to={`/${locale}/create`}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <TextField
                                            color={navElementColor}
                                            size="s"
                                            weight={navElementWeight}
                                        >
                                            {t('header.create')}
                                        </TextField>
                                    </Link>
                                </>
                            ) : (
                                <>
                                    {/* <Link
                                        to={withSiteLocale('/features', locale)}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <TextField
                                            color={navElementColor}
                                            size="s"
                                            weight={navElementWeight}
                                        >
                                            {t('header.howItWorks')}
                                        </TextField>
                                    </Link> */}
                                    {/* <Link to="/about">
                                        <TextField
                                            color={navElementColor}
                                            weight={navElementWeight}
                                        >
                                            About
                                        </TextField>
                                    </Link> */}
                                    <Link
                                        to={withSiteLocale(
                                            '/contact-us',
                                            locale
                                        )}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <TextField
                                            color={navElementColor}
                                            size="s"
                                            weight={navElementWeight}
                                        >
                                            {t('common.contact')}
                                        </TextField>
                                    </Link>
                                    <Link
                                        to={withSiteLocale('/login', locale)}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <TextField
                                            color={navElementColor}
                                            size="s"
                                            weight={navElementWeight}
                                        >
                                            {t('common.login')}
                                        </TextField>
                                    </Link>
                                    <Link
                                        to={withSiteLocale('/register', locale)}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <Button
                                            text={t('landing.joinNow')}
                                            variant={isOpen ? 'white' : 'green'}
                                            size="sm"
                                        />
                                        {/* <TextField
                                            color={isOpen ? 'white' : 'green'}
                                            size="s"
                                            weight={navElementWeight}
                                        >
                                            {t('header.signIn')}
                                        </TextField> */}
                                    </Link>
                                </>
                            )}
                        </>
                    )}
                </nav>
                {isAuthenticated && (
                    <div className="right-header">
                        <div className="header-icons">
                            {iconFontReady ? (
                                <SearchBar />
                            ) : (
                                <div className="icon-placeholder" />
                            )}
                        </div>
                        {iconFontReady ? (
                            <Notifications />
                        ) : (
                            <div className="icon-placeholder" />
                        )}
                        <UserMenu authData={auth.authData} />
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
